/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { createStore } from 'redux';
import isEmpty from 'lodash/isEmpty';
import { array } from 'prop-types';
import MessageBox from 'yoda-core-components/lib/components/MessageBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import RevieveAddToCartReducer from '../../reducers/RevieveAddToCartReducer';
import analyticsActions from '../../actions/AnalyticsAction';

const RevieveMessageBox = ({ analyticsPayload = [] }) => {
    const {
        context: {
            deviceType: { isMobile = false } = {},
            revieveConfiguration: {
                allErrorMessageATC = "Sorry, these items can't be added to cart at the moment.",
                allSuccessMessageATC = 'All items added to cart.',
                singleErrorMessageATC = 'Sorry, this item can’t be added to cart at the moment.',
                singleSuccessMessageATC = '1 item added to cart.',
            } = {},
        } = {},
        revieveAddToCart: {
            cartFailure = [],
            cartSuccess = [],
            totalAddToCartRequestCount: totalItems = 0,
        } = {},
    } = useSelector((store) => store);

    const dispatch = useDispatch();

    const [customElement, setCustomElement] = useState(null);
    const [messageContainer, setMessageContainer] = useState(null);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const store = createStore(RevieveAddToCartReducer);

    useEffect(() => {
        if (totalItems > 0) {
            const revieveDialogElement = document.querySelector('#revieve-dialog');

            if (revieveDialogElement) {
                const messageDismissalTimer = messageType === 'success' ? 3500 : 5000;
                const cartFailureCount = cartFailure.length;
                const cartSuccessCount = cartSuccess.length;
                const isSingleItem = totalItems === 1;
                const isSingleSuccess = isSingleItem && cartFailureCount === 0;
                const isSingleError = isSingleItem && cartFailureCount <= 1;
                if (cartSuccessCount) {
                    const cartSkuIds = cartSuccess.map(({ skuId }) => skuId);
                    const updatedPayload = [];

                    analyticsPayload.length &&
                        cartSkuIds.length &&
                        analyticsPayload.forEach((eachObj) => {
                            if (cartSkuIds.includes(eachObj.productInfo.productSKU)) {
                                updatedPayload.push(eachObj);
                            }
                        });

                    updatedPayload.length &&
                        dispatch(
                            analyticsActions.triggerRevieveAddToCartAnalytics({
                                data: updatedPayload,
                            })
                        );

                    setMessage(`${cartSuccessCount} of ${totalItems} items added to cart.`);
                    if (cartSuccessCount === totalItems) {
                        setMessage(allSuccessMessageATC);
                    }
                    if (isSingleSuccess) {
                        setMessage(singleSuccessMessageATC);
                    }
                    setMessageType('success');
                } else {
                    setMessage(allErrorMessageATC);
                    if (isSingleError) {
                        setMessage(singleErrorMessageATC);
                    }
                    setMessageType('error');
                }

                revieveDialogElement
                    .appendChild(document.createElement('div'))
                    .classList.add('revieve-jcp-message-container', dt(['absolute']));
                setCustomElement(revieveDialogElement);

                setShowMessage(true);
                setTimeout(() => setShowMessage(false), messageDismissalTimer);
            }
        }
    }, [totalItems]);

    useEffect(() => {
        const messageContainerPlaceholder = document.querySelector(
            '.revieve-jcp-message-container'
        );
        if (messageContainerPlaceholder) {
            messageContainerPlaceholder.style.cssText = `
            bottom: ${isMobile ? '68' : '80'}px;
            left: 50%;
            max-width: 500px;
            width: 100%;
            transform: translateX(-50%);
            padding: 0 21px;
            `;

            setMessageContainer(messageContainerPlaceholder);
        }
    }, [customElement]);

    return (
        messageContainer &&
        !isEmpty(messageType) &&
        ReactDOM.render(
            <Provider store={store}>
                <MessageBox
                    message={message}
                    messageType={messageType}
                    showMessage={showMessage}
                    shouldAnimate
                />
            </Provider>,
            messageContainer
        )
    );
};

RevieveMessageBox.defaultProps = {
    analyticsPayload: [],
};

RevieveMessageBox.propTypes = {
    analyticsPayload: array,
};

export default RevieveMessageBox;
